import {
    CustomerInformationInputType,
    CI_INPUT,
    TEXT_MAX_LENGTH,
    TEL_TEXT_MAX_LENGTH,
    DETAIL_MAX_LENGTH,
    MAIL_ADDRESS_MAX_LENGTH,
} from '../../types/common/CustomerInformationType';

import { checkLength, checkMailAddressFormat, checkPhoneFormat } from '../../utils/stringCheckUtil';
import { ErrorMessages } from '../../types/common/Messages';

// 入力内容チェック
const ciInputValidation = (input: CustomerInformationInputType, setCiErrorMessage: (value: Array<string>) => void) => {
    // error stateの初期化
    setCiErrorMessage([]);
    const errorMessages: Array<string> = [];
    const modalErrorMessages: Array<string> = [];

    let checkResult = true;
    // 文字数チェックと必須入力チェック VAL-04 VAL-05
    // 会社名
    if (input.company.length === 0) {
        // 必須チェック
        errorMessages.push(ErrorMessages.CI_VAL05.replace('%1', CI_INPUT.COMPANY));
        if (!modalErrorMessages.includes(ErrorMessages.CI_VAL05_MODAL)) {
            modalErrorMessages.push(ErrorMessages.CI_VAL05_MODAL);
        }
        checkResult = false;
    }
    // 桁数チェック
    const companyErrorCheckMessage = checkLength(input.company, CI_INPUT.COMPANY, TEXT_MAX_LENGTH);
    if (companyErrorCheckMessage !== '') {
        errorMessages.push(companyErrorCheckMessage);
        modalErrorMessages.push(companyErrorCheckMessage);
        checkResult = false;
    }

    // 部署名
    if (input.division.length === 0) {
        // 必須チェック
        errorMessages.push(ErrorMessages.CI_VAL05.replace('%1', CI_INPUT.DIVISION));
        if (!modalErrorMessages.includes(ErrorMessages.CI_VAL05_MODAL)) {
            modalErrorMessages.push(ErrorMessages.CI_VAL05_MODAL);
        }
        checkResult = false;
    }
    const divisionErrorCheckMessage = checkLength(input.division, CI_INPUT.DIVISION, TEXT_MAX_LENGTH);
    if (divisionErrorCheckMessage !== '') {
        // 桁数チェック
        errorMessages.push(divisionErrorCheckMessage);
        modalErrorMessages.push(divisionErrorCheckMessage);
        checkResult = false;
    }

    // お名前
    if (input.name.length === 0) {
        // 必須チェック
        errorMessages.push(ErrorMessages.CI_VAL05.replace('%1', CI_INPUT.NAME));
        if (!modalErrorMessages.includes(ErrorMessages.CI_VAL05_MODAL)) {
            modalErrorMessages.push(ErrorMessages.CI_VAL05_MODAL);
        }
        checkResult = false;
    }
    const nameErrorCheckMessage = checkLength(input.name, CI_INPUT.NAME, TEXT_MAX_LENGTH);
    if (nameErrorCheckMessage !== '') {
        // 桁数チェック
        errorMessages.push(nameErrorCheckMessage);
        modalErrorMessages.push(nameErrorCheckMessage);
        checkResult = false;
    }

    // ふりがな
    if (input.kana.length === 0) {
        // 必須チェック
        errorMessages.push(ErrorMessages.CI_VAL05.replace('%1', CI_INPUT.KANA));
        if (!modalErrorMessages.includes(ErrorMessages.CI_VAL05_MODAL)) {
            modalErrorMessages.push(ErrorMessages.CI_VAL05_MODAL);
        }
        checkResult = false;
    }
    const kanaErrorCheckMessage = checkLength(input.kana, CI_INPUT.KANA, TEXT_MAX_LENGTH);
    if (kanaErrorCheckMessage !== '') {
        // 桁数チェック
        errorMessages.push(kanaErrorCheckMessage);
        modalErrorMessages.push(kanaErrorCheckMessage);
    }

    // メールアドレス
    if (input.mail.length === 0) {
        // 必須チェック
        errorMessages.push(ErrorMessages.CI_VAL05.replace('%1', CI_INPUT.MAIL));
        if (!modalErrorMessages.includes(ErrorMessages.CI_VAL05_MODAL)) {
            modalErrorMessages.push(ErrorMessages.CI_VAL05_MODAL);
        }
        checkResult = false;
    }
    const mailErrorCheckMessage = checkLength(input.mail, CI_INPUT.MAIL, MAIL_ADDRESS_MAX_LENGTH);
    if (mailErrorCheckMessage !== '') {
        // 桁数チェック
        errorMessages.push(mailErrorCheckMessage);
        modalErrorMessages.push(mailErrorCheckMessage);
        checkResult = false;
    }

    // メールアドレス確認
    if (input.mailReInput.length === 0) {
        // 必須チェック
        errorMessages.push(ErrorMessages.CI_VAL05.replace('%1', CI_INPUT.MAIL_RE));
        if (!modalErrorMessages.includes(ErrorMessages.CI_VAL05_MODAL)) {
            modalErrorMessages.push(ErrorMessages.CI_VAL05_MODAL);
        }
        checkResult = false;
    }
    const mailReInputErrorCheckMessage = checkLength(input.mailReInput, CI_INPUT.MAIL_RE, MAIL_ADDRESS_MAX_LENGTH);
    if (mailReInputErrorCheckMessage !== '') {
        // 桁数チェック
        errorMessages.push(mailReInputErrorCheckMessage);
        modalErrorMessages.push(mailReInputErrorCheckMessage);
        checkResult = false;
    }

    // 電話番号
    if (input.phone !== undefined) {
        const phoneErrorCheckMessage = checkLength(input.phone, CI_INPUT.PHONE, TEL_TEXT_MAX_LENGTH);
        // 桁数チェック
        if (phoneErrorCheckMessage !== '') {
            errorMessages.push(phoneErrorCheckMessage);
            modalErrorMessages.push(phoneErrorCheckMessage);
            checkResult = false;
        }
    }

    // 「当社を知ったきっかけ」備考
    if (input.reasonComment !== undefined && input.reasonComment.length > DETAIL_MAX_LENGTH) {
        // 桁数チェック
        const addMessage = ErrorMessages.CI_VAL04.replace('%1', CI_INPUT.REASON_DETAIL).replace(
            '%2',
            DETAIL_MAX_LENGTH.toString()
        );
        errorMessages.push(addMessage);
        modalErrorMessages.push(addMessage);
        checkResult = false;
    }

    // 電話番号の入力形式チェック VAL-01
    if (input.phone && !checkPhoneFormat(input.phone)) {
        errorMessages.push(ErrorMessages.CI_VAL01);
        modalErrorMessages.push(ErrorMessages.CI_VAL01);
        checkResult = false;
    }

    // メールアドレスと確認メールアドレス同一チェック VAL-03
    if (input.mail !== input.mailReInput) {
        errorMessages.push(ErrorMessages.CI_VAL03);
        modalErrorMessages.push(ErrorMessages.CI_VAL03);
        checkResult = false;
    }

    // メールアドレスの入力形式チェック VAL-02
    if (!checkMailAddressFormat(input.mail ?? '')) {
        errorMessages.push(ErrorMessages.CI_VAL02);
        modalErrorMessages.push(ErrorMessages.CI_VAL02);
        checkResult = false;
    }

    // 個人情報同意チェック
    if (!input.pPolicyCheck) {
        modalErrorMessages.push(ErrorMessages.CI_VAL05_P_POLCIY);
    }

    if (!checkResult) {
        setCiErrorMessage(errorMessages);
    }

    return modalErrorMessages;
};

export const CustomerInformationLogic = {
    ciInputValidation,
};
